import React, { useState, useEffect } from "react";
import { FormError } from "../../../components/Error";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  registerRequest,
  clearRegisterSuccess,
  getUserRequest,
} from "../../../redux/action";
import {
  BiUser,
  BiEnvelope,
  BiPhone,
  BiLockAlt,
  BiLoaderAlt,
  BiGift,
} from "react-icons/bi";
import { GoBack } from "../../../components/Layout/GoBack";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Register = () => {
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [userRef, setUserRef] = useState("");

  const dispatch = useDispatch();
  const history = useHistory();

  const {
    getUserLoading,
    getUserError,
    registerSuccess,
    registerError,
    registerLoading,
    user,
    singleUser,
  } = useSelector((state) => {
    const {
      success: { register: registerSuccess },
      errors: { getUser: getUserError, register: registerError },
    } = state.ajaxStatuses;

    const { registerLoading, getUserLoading } = state.loadingIndicator;

    const { user, singleUser } = state.userData;

    return {
      getUserLoading,
      getUserError,
      registerSuccess,
      registerError,
      registerLoading,
      user,
      singleUser,
    };
  });

  let query = useQuery();

  const formik = useFormik({
    initialValues: {
      userName: "",
      phone: "",
      email: "",
      password: "",
    },
    validationSchema: yup.object({
      userName: yup
        .string()
        .required("username is required")
        .max(32, "username is too long")
        .trim()
        .matches(/^[a-zA-Z]+$/, "username must be alphabetic without spacing"),

      phone: yup.string().required("Phone is required"),
      email: yup
        .string()
        .email("Email is not valid")
        .required("Email is required"),
      password: yup.string().required("Password is required"),
    }),

    onSubmit: (prop) => {
      if (prop.password !== confirmPassword) {
        toast.error("Password does not match");
      } else {
        // let encrypted = CryptoJS.AES.encrypt(
        //   JSON.stringify(prop.password),
        //   "my-secret-key@123"
        // ).toString();
        // prop.investmentDetail = encrypted;

        console.log(prop);
        let formData = prop;
        let refId = query.get("refId");

        dispatch(registerRequest({ formData, refId }));
      }
    },
  });

  useEffect(() => {
    if (registerError) {
      toast.error(registerError, {
        duration: 3000,
      });
    }
  }, [registerError]);

  useEffect(() => {
    if (registerSuccess) {
      // toast.success(registerSuccess, {
      //   duration: 3000,
      // });

      history.push("/dashboard/home");

      dispatch(clearRegisterSuccess());
    }
  }, [registerSuccess]);

  useEffect(() => {
    let refId = query.get("refId");
    if (refId) {
      setUserRef(refId);
      dispatch(getUserRequest(refId));
    }
  }, [getUserRequest]);

  useEffect(() => {
    if (getUserError) {
      setUserRef("");
    }
  }, [getUserError]);

  return (
    /* 
      Locked to w-[428px] to perfectly replicate the mobile application screen size. 
      Center it on the page with mx-auto if viewing on a desktop monitor.
    */
    <div
      className="w-[428px] mx-auto bg-[#f8faff] min-h-screen relative font-sans text-slate-900 pb-10 shadow-[0_0_50px_rgba(0,0,0,0.1)] overflow-hidden bg-cover bg-center"
      style={{ backgroundImage: "url('/img/new/background/authbg.jpeg')" }}
    >
      <GoBack />

      {/* --- Header --- */}
      <div className="relative z-10 px-8 text-center pb-8">
        <h1 className="text-[28px] font-semibold text-[#071330] mb-3">
          Create Account
        </h1>
        <p className="text-slate-500 text-sm leading-relaxed px-2">
          Open your Africa's Trusted Digital Platform account in minutes.
        </p>
      </div>

      {/* --- Form Card --- */}
      <div className="relative z-10 bg-white mx-4 rounded-[2rem] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.03)] border border-gray-50">
        <form onSubmit={formik?.handleSubmit} className="flex flex-col gap-5">
          {/* Conditional Referral Field */}
          {userRef && (
            <div>
              <label className="block text-[11px] font-semibold text-[#1a4bdf] tracking-[0.15em] uppercase mb-2 ml-1">
                Referred by
              </label>
              <div className="relative">
                <div className="absolute left-4 top-1/2 -translate-y-1/2 text-[#1a4bdf]">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <input
                  type="text"
                  value={singleUser?.userName}
                  readOnly
                  className="w-full bg-blue-50/50 border border-[#dce5fc] rounded-2xl py-4 pl-12 pr-4 text-sm text-[#1a4bdf] cursor-default focus:outline-none"
                />
              </div>
            </div>
          )}

          {/* User Name */}
          <div>
            <label className="block text-[11px] font-semibold text-[#1a4bdf] tracking-[0.15em] uppercase mb-2 ml-1">
              User Name
            </label>
            <div className="relative">
              <div className="absolute left-4 top-1/2 -translate-y-1/2 text-[#1a4bdf]">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <input
                type="text"
                {...formik?.getFieldProps("userName")}
                placeholder="Choose a username"
                className="w-full bg-white border border-[#dce5fc] rounded-2xl py-4 pl-12 pr-4 text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:border-[#1a4bdf] transition-colors"
                required
              />
            </div>
            {formik?.errors?.userName && formik?.touched?.userName && (
              <p className="text-red-500 text-xs ml-2 mt-1">
                {formik.errors.userName}
              </p>
            )}
          </div>

          {/* Email Address */}
          <div>
            <label className="block text-[11px] font-semibold text-[#1a4bdf] tracking-[0.15em] uppercase mb-2 ml-1">
              Email Address
            </label>
            <div className="relative">
              <div className="absolute left-4 top-1/2 -translate-y-1/2 text-[#1a4bdf]">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <input
                type="email"
                {...formik?.getFieldProps("email")}
                placeholder="name@example.com"
                className="w-full bg-white border border-[#dce5fc] rounded-2xl py-4 pl-12 pr-4 text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:border-[#1a4bdf] transition-colors"
                required
              />
            </div>
            {formik?.errors?.email && formik?.touched?.email && (
              <p className="text-red-500 text-xs ml-2 mt-1">
                {formik.errors.email}
              </p>
            )}
          </div>

          {/* Phone */}
          <div>
            <label className="block text-[11px] font-semibold text-[#1a4bdf] tracking-[0.15em] uppercase mb-2 ml-1">
              Phone
            </label>
            <div className="relative">
              <div className="absolute left-4 top-1/2 -translate-y-1/2 text-[#1a4bdf]">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              </div>
              <input
                type="tel"
                {...formik?.getFieldProps("phone")}
                placeholder="Mobile number"
                className="w-full bg-white border border-[#dce5fc] rounded-2xl py-4 pl-12 pr-4 text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:border-[#1a4bdf] transition-colors"
                required
              />
            </div>
            {formik?.errors?.phone && formik?.touched?.phone && (
              <p className="text-red-500 text-xs ml-2 mt-1">
                {formik.errors.phone}
              </p>
            )}
          </div>

          {/* Password */}
          <div>
            <label className="block text-[11px] font-semibold text-[#1a4bdf] tracking-[0.15em] uppercase mb-2 ml-1">
              Password
            </label>
            <div className="relative">
              <div className="absolute left-4 top-1/2 -translate-y-1/2 text-[#1a4bdf]">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect
                    x="3"
                    y="11"
                    width="18"
                    height="11"
                    rx="2"
                    ry="2"
                  ></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
              </div>
              <input
                type="password"
                {...formik?.getFieldProps("password")}
                placeholder="Create strong password"
                className="w-full bg-white border border-[#dce5fc] rounded-2xl py-4 pl-12 pr-12 text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:border-[#1a4bdf] transition-colors"
                required
              />
              <div className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 cursor-pointer hover:text-slate-600">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
              </div>
            </div>
            {formik?.errors?.password && formik?.touched?.password && (
              <p className="text-red-500 text-xs ml-2 mt-1">
                {formik.errors.password}
              </p>
            )}
          </div>

          {/* Confirm Password */}
          <div>
            <label className="block text-[11px] font-semibold text-[#1a4bdf] tracking-[0.15em] uppercase mb-2 ml-1">
              Confirm Password
            </label>
            <div className="relative">
              <div className="absolute left-4 top-1/2 -translate-y-1/2 text-[#1a4bdf]">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect
                    x="3"
                    y="11"
                    width="18"
                    height="11"
                    rx="2"
                    ry="2"
                  ></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
              </div>
              <input
                type="password"
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Repeat password"
                className="w-full bg-white border border-[#dce5fc] rounded-2xl py-4 pl-12 pr-12 text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:border-[#1a4bdf] transition-colors"
                required
              />
              <div className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 cursor-pointer hover:text-slate-600">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="mt-2">
            <button
              type="submit"
              disabled={registerLoading}
              className="w-full bg-[#1a4bdf] hover:bg-blue-700 text-white font-medium py-4 rounded-xl flex items-center justify-center relative shadow-lg shadow-blue-600/20 transition-all active:scale-[0.98] disabled:opacity-70"
            >
              <span className="text-[17px]">
                {registerLoading ? "Creating..." : "Sign Up"}
              </span>
              {!registerLoading && (
                <div className="absolute right-4 w-7 h-7 bg-white/20 rounded-full flex items-center justify-center">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </div>
              )}
            </button>
          </div>

          {/* Login Link */}
          <div className="text-center mt-4 pb-2">
            <p className="text-[15px] text-slate-500 font-medium">
              Already have an account?{" "}
              <Link to="/signin">
                <span className="text-[#1a4bdf] font-semibold cursor-pointer hover:text-blue-700 transition-colors">
                  Login
                </span>
              </Link>
            </p>
          </div>
        </form>
      </div>

      {/* --- Footer Security Note --- */}
      <div className="flex items-center justify-center gap-2 mt-8 text-slate-500 text-sm">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#1a4bdf"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          <polyline points="9 12 11 14 15 10"></polyline>
        </svg>
        <span className="font-medium">
          Your data is safe and secure with us
        </span>
      </div>
    </div>
  );
};

export default Register;
